import React, { useContext } from "react";
import { ColorSelector } from "../../components/ColorSelector";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";

const colours = [
  { filter: "screenshotDetailStyleBackground", display: "det back" },
  { filter: "screenshotDisplayStyleBackground", display: "disp back" },
  { filter: "screenshotLabelStyleBackground", display: "butn back" },
  { filter: "screenshotDetailStyleBorderColor", display: "det bor" },
  { filter: "screenshotLabelStyleBorderColor", display: "butn bor" },
  { filter: "screenshotLabelStyleColor", display: "butn text" },
  { filter: "screenshotDisplayStyleColor", display: "disp text" },
  { filter: "screenshotDetailStyleColor", display: "det text" },
];

const marginTop = 5;

export const UploadFilterPanel = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { flowConfig } = store;

  const changefilter = (val, key) => {
    const newFilter = { ...flowConfig, [key]: val };
    dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: newFilter });
    dispatch({ type: actionTypes.SET_NEWFLOWLAYOUTTRIGGER, payload: true });
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        marginTop: 10,
        display: "block",
      }}
    >
      <div>
        {/* screenshotLabelStyleFontSize */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={5}
            max={60}
            value={flowConfig.screenshotLabelStyleFontSize}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotLabelStyleFontSize"
              )
            }
          />
          {`butn font size ${flowConfig.screenshotLabelStyleFontSize}`}
        </div>
        {/* screenshotLabelStyleFontWeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={100}
            max={900}
            step={100}
            value={flowConfig.screenshotLabelStyleFontWeight}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotLabelStyleFontWeight"
              )
            }
          />
          {`butn font Weight ${flowConfig.screenshotLabelStyleFontWeight}`}
        </div>
        {/* screenshotDetailStyleFontSize */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={5}
            max={60}
            value={flowConfig.screenshotDetailStyleFontSize}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDetailStyleFontSize"
              )
            }
          />
          {`det font size ${flowConfig.screenshotDetailStyleFontSize}`}
        </div>
        {/* screenshotDetailStyleFontWeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={100}
            max={900}
            step={100}
            value={flowConfig.screenshotDetailStyleFontWeight}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDetailStyleFontWeight"
              )
            }
          />
          {`det font Weight ${flowConfig.screenshotDetailStyleFontWeight}`}
        </div>
        {/* screenshotDisplayStyleFontSize */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={5}
            max={60}
            value={flowConfig.screenshotDisplayStyleFontSize}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDisplayStyleFontSize"
              )
            }
          />
          {`disp font size ${flowConfig.screenshotDisplayStyleFontSize}`}
        </div>
        {/* screenshotDisplayStyleFontWeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={100}
            max={900}
            step={100}
            value={flowConfig.screenshotDisplayStyleFontWeight}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDisplayStyleFontWeight"
              )
            }
          />
          {`disp font Weight ${flowConfig.screenshotDisplayStyleFontWeight}`}
        </div>
        {/* screenshotDetailStylePadding */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.screenshotDetailStylePadding}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDetailStylePadding"
              )
            }
          />
          {`det padding ${flowConfig.screenshotDetailStylePadding}`}
        </div>
        {/* screenshotDisplayStylePadding */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.screenshotDisplayStylePadding}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDisplayStylePadding"
              )
            }
          />
          {`disp padding ${flowConfig.screenshotDisplayStylePadding}`}
        </div>
        {/* screenshotLabelStylePadding */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.screenshotLabelStylePadding}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotLabelStylePadding"
              )
            }
          />
          {`butn padding ${flowConfig.screenshotLabelStylePadding}`}
        </div>
        {/* screenshotDetailStyleBorderWidth */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={20}
            value={flowConfig.screenshotDetailStyleBorderWidth}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDetailStyleBorderWidth"
              )
            }
          />
          {`det b width ${flowConfig.screenshotDetailStyleBorderWidth}`}
        </div>
        {/* screenshotLabelStyleBorderWidth */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={20}
            value={flowConfig.screenshotLabelStyleBorderWidth}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotLabelStyleBorderWidth"
              )
            }
          />
          {`butn b width ${flowConfig.screenshotLabelStyleBorderWidth}`}
        </div>
        {/* screenshotDetailStyleBorderRadius */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.screenshotDetailStyleBorderRadius}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotDetailStyleBorderRadius"
              )
            }
          />
          {`det b radius ${flowConfig.screenshotDetailStyleBorderRadius}`}
        </div>
        {/* screenshotLabelStyleBorderRadius */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.screenshotLabelStyleBorderRadius}
            onChange={(e) =>
              changefilter(
                e.target.valueAsNumber,
                "screenshotLabelStyleBorderRadius"
              )
            }
          />
          {`butn b radius ${flowConfig.screenshotLabelStyleBorderRadius}`}
        </div>
      </div>
      <ColorSelector
        colours={colours}
        changefilter={changefilter}
        filter={flowConfig}
      />
    </div>
  );
};
